import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "loader_svg__loader",
  color: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"loader_svg__b\"><stop offset=\"0%\" stop-color=\"currentColor\" stop-opacity=\"0\"></stop><stop offset=\"100%\" stop-color=\"currentColor\" stop-opacity=\".5\"></stop></linearGradient><linearGradient id=\"loader_svg__a\"><stop offset=\"0%\" stop-color=\"currentColor\"></stop><stop offset=\"100%\" stop-color=\"currentColor\" stop-opacity=\".5\"></stop></linearGradient></defs><g stroke-width=\"2\"><path stroke=\"url(#loader_svg__a)\" d=\"M22 12a10 10 0 0 1-20 0\"></path><path stroke=\"url(#loader_svg__b)\" d=\"M2 12a10 10 0 0 1 20 0\"></path></g>", 2)
  ]))]))
}
export default { render: render }